import { inject, Injectable } from '@angular/core';
import {
  CanActivateFn,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { OrganizerSharedAbstractGuard } from '~/organizer/shared/guards/guard.abstract';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService extends OrganizerSharedAbstractGuard {
  protected readonly errorCode = ErrorCodesEnum.OrganizerSharedHasActivity;

  constructor(
    private readonly activityService: OrganizerSharedActivityService,
    private readonly organizationService: OrganizerSharedOrganizationService,
    protected readonly errorCodeService: ErrorCodeService,
    protected readonly router: Router
  ) {
    super(errorCodeService, router);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): true | UrlTree {
    const excludedPaths = [
      'organizer.activity-sharing.steps-3',
      'organizer.activity-planning.steps-2',
      'organizer.activity-planning.my-planning-validation',
      'organizer.activity-planning.activity',
      'organizer.activity-sharing.share',
      'organizer.activity-sharing.success',
    ];

    if (!excludedPaths.includes(route.data.localizeRouter.path)) {
      this.activityService
        .getActivity(route.queryParams.activityId)
        .subscribe((activity) => {
          if (
            activity?.organizationIdentifier !==
            this.organizationService.organization?.identifier
          ) {
            activity = null;

            return this.redirectInvalid();
          }
        });
      return true;
    }
  }
}

export const OrganizerSharedHasActivityGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): true | UrlTree => {
  return inject(PermissionsService).canActivate(next, state);
};
